import { render, staticRenderFns } from "./_dailyWinloseByMatchDetail.vue?vue&type=template&id=16cb4c01&lang=pug&"
import script from "./_dailyWinloseByMatchDetail.vue?vue&type=script&lang=js&"
export * from "./_dailyWinloseByMatchDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports